import { FeatureAppEnvironment } from '@feature-hub/core';
import { FeatureService } from '@/enums/FeatureServiceDefinition';
import { AvpDgaFeatureAppDependencies } from '@/index';

export const beforeCreate =
  (contentConfig?: Record<string, unknown>) =>
  (env: FeatureAppEnvironment<Partial<AvpDgaFeatureAppDependencies>, unknown>): void => {
    const { featureServices } = env;

    const faContentService = featureServices?.[FeatureService.CONTENT_SERVICE];
    if (faContentService && contentConfig) {
      faContentService.content = contentConfig;
    }
  };
